import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { LevelOfServiceService } from 'src/app/component/level-of-service/service/level-of-service.service';
import { ServiceAreasService } from 'src/app/component/service-areas/service-areas-service/service-areas.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-member-trips-modal',
  templateUrl: './member-trips-modal.component.html',
  styleUrls: ['./member-trips-modal.component.css']
})
export class MemberTripsModalComponent implements OnInit, OnDestroy {
  tripsList = [];
  @Input() member
  @Output() onClose = new EventEmitter();
  timeZone;
  user;
  todayDate = [];
  preCooperates: any;
  preServiceAreas: any;
  preLevelOfServices: any;
  preSpaceTypes: any;
  editTripModalObj

  constructor(
    private sharedDataService : SharedDataService,
    private assignTripService: AssigTripsService,
    private serviceArea: ServiceAreasService,
    private levelOfServiceService: LevelOfServiceService
  ) { }
 

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.timeZone = data.timeZone;
          this.user = data;
          this.todayDate = [
            moment.tz(this.timeZone).startOf("day").toISOString(),
            moment.tz(this.timeZone).endOf("day").toISOString(),
          ];
          this.getTrips();
          this.getCorporateUserList();
          this.getServiceAreas();
          this.getLevelOfService();
          this.getSpaceTypes();



        }
      });
  }

  getTrips(){

   const queryParam = {
    status: 'member',
     scheduleTime: this.todayDate[0]+','+ this.todayDate[1],
    client : this.member._id

    }
    this.assignTripService.getMemberAllTrips(queryParam)
    .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.tripsList = data;
        }
      });
  }

  getCorporateUserList() {
    this.assignTripService
      .getCorporateUserList()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      });
  }
  
  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  onDateChange(event) {
    this.todayDate = [
      event[0].toISOString(),
      event[1].endOf("day").toISOString(),
    ];
    this.getTrips();
  }

  closeModal(){
    this.onClose.emit();
  }

  ngOnDestroy(): void {
  }

  editTrip(assign){
    this.editTripModalObj = assign._id
  }

    onEditTrip(event) {
      if (event) {
       console.log(event);
        const idx = this.tripsList.findIndex((t) => t._id === event._id);
             if (
               moment(event.appointmentTime).format("YYYY-MM-DD") !==
               moment(this.tripsList[idx].appointmentTime).format(
                 "YYYY-MM-DD"
               ) ||
               moment(event.scheduleTime).format("YYYY-MM-DD") !==
               moment(this.tripsList[idx].scheduleTime).format("YYYY-MM-DD")
             ) {
               this.tripsList.splice(idx, 1);
             } else {
               this.tripsList[idx] = event;
             }
       this.editTripModalObj = null
      }
    }

}
